import script from "./EvidenceGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./EvidenceGallery.vue?vue&type=script&setup=true&lang=js"

import "./EvidenceGallery.vue?vue&type=style&index=0&id=6ed50691&lang=scss&scoped=true"
import "./EvidenceGallery.vue?vue&type=style&index=1&id=6ed50691&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed50691"]])

export default __exports__